<template>
  <div>
    <MineHeaderView @click-icon="openMenu" />
    <GoBackView />
    <MineMenuView ref="mmv" />
    <div class="pro-list-box">
      <van-tabs v-model="active" color="#7b8c9c">
        <van-tab title="全部" />
        <van-tab title="待支付" />
        <van-tab title="已完成" />
        <van-tab title="作废" />
      </van-tabs>
      <div class="pro-data-lst">
        <DiscountOrderItemView :state="0" />
        <DiscountOrderItemView :state="1" />
        <DiscountOrderItemView :state="2" />
      </div>
      <div><van-empty description="暂无记录" /></div>
      <div><van-loading size="24px" vertical>加载中...</van-loading></div>
    </div>
  </div>
</template>

<script>
import { MineHeaderView, MineMenuView,DiscountOrderItemView } from './components/index'
import GoBackView from '@/components/goback/index.vue'
export default {
  name: 'MyProCartView',
  components: { MineHeaderView, MineMenuView, GoBackView,DiscountOrderItemView },
  data () {
    return {
      isrefresh: false,
      loading: false,
      finished: false,
      list: null,
      page: 1,
      limit: 10,
      active:null
    }
  },
  methods: {
    openMenu () {
      const that = this
      this.$nextTick(() => {
        that.$refs.mmv.showMenu = true
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.pro-list-box {
  margin: 40px 10px 0px;
  padding: 15px 12px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  height: calc(100vh - 90px);
  .pro-data-lst {
    height: calc(100vh - 150px);
    overflow-y: auto;
  }
  .pro-data-lst::-webkit-scrollbar {
            display: none;
        }
}
</style>
